// extracted by mini-css-extract-plugin
export default {"price":"cbUZnO","mobileFeesContainer":"wAgtJV"};